import { c as _c } from "react/compiler-runtime";
import { PrimaryButton } from '@systemeio/ui';
import { useGetNewsletterView } from 'modules/newsletters/single/hooks/use-get-newsletter-view';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { useCreateSplitTest } from 'modules/newsletters/split-test/hooks/use-create-split-test';
import React, { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { SplitTestIcon } from '@systemeio/ui/icons';
interface DuplicateNewsletterModalProps {
  newsletterId: NewsletterId;
  isDisabled: boolean;
}
export const CreateSplitTestModal = t0 => {
  const $ = _c(27);
  const {
    newsletterId,
    isDisabled
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isOpened, setIsOpened] = useState(false);
  const {
    createSplitTest
  } = useCreateSplitTest();
  let t1;
  if ($[0] !== newsletterId) {
    t1 = {
      newsletterId
    };
    $[0] = newsletterId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    mutateNewslettersData
  } = useGetNewsletterView(t1);
  let t2;
  if ($[2] !== createSplitTest || $[3] !== mutateNewslettersData || $[4] !== newsletterId) {
    t2 = async () => {
      ;
      try {
        const response = await createSplitTest(newsletterId);
        await mutateNewslettersData(data => data && {
          ...data,
          mailingSplitTest: response
        });
      } catch (t3) {
        const e = t3;
        throw e;
      }
    };
    $[2] = createSplitTest;
    $[3] = mutateNewslettersData;
    $[4] = newsletterId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleConfirm = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpened(true);
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SplitTestIcon className="fill-background-secondary h-[20px] w-[20px]" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("dashboard.newsletter_editor.split_test.create_title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="hidden lg:flex">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isDisabled || $[13] !== t6) {
    t7 = <PrimaryButton onClick={t3} disabled={isDisabled}>{t4}{t6}</PrimaryButton>;
    $[12] = isDisabled;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("dashboard.newsletter_editor.split_test.create_description");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsOpened(false);
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== handleConfirm) {
    t10 = async () => {
      await handleConfirm();
    };
    $[18] = handleConfirm;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== isOpened || $[21] !== t10 || $[22] !== t8) {
    t11 = <ConfirmationModal confirmationText={t8} opened={isOpened} onClose={t9} onConfirm={t10} />;
    $[20] = isOpened;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t7) {
    t12 = <React.Fragment>{t7}{t11}</React.Fragment>;
    $[24] = t11;
    $[25] = t7;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};